module.exports = __webpack_public_path__ + "img/bluetick.773eff91.svg";